import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctDecimals, FctValue } from '../../../../Fct/generics';
import { FaLessThan } from 'react-icons/fa';
import { supportedContracts } from '../constants';
export var LessThan = createPlugin({
    protocol: 'TOKEN_VALIDATOR',
    type: 'VALIDATOR',
    method: 'lessThan',
    description: 'Check if a amount2 is less than amount1',
    supportedContracts: supportedContracts,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                valueToCheck: new FctValue({ destination: 'wei_amount', isPreview: true, icon: FaLessThan }),
                decimals1: new FctDecimals({}),
                threshold: new FctValue({ destination: 'wei_amount', isPreview: true }),
                decimals2: new FctDecimals({}),
                decimalsOut: new FctDecimals({}),
            },
        },
        output: {
            result: new FctValue({
                description: 'amount2 - amount1',
                innerIndex: 0,
            }),
        },
    }); },
});
